import { useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'

const DoubleColumn = ({ children }) => {
    const outputChildren = useMemo(() => {
        const _children = Array.isArray(children) ? children : [children]
        let rows = []

        for (let i = 0; i < _children.length; i += 2) {
            const firstChild = _children[i] ? <Col lg={6} md={6} sm={6}>{_children[i]}</Col> : null
            const secondChild = _children[i + 1] ? <Col lg={6} md={6} sm={6}>{_children[i + 1]}</Col> : null
            
            rows.push(
                <Row key={i}>
                    {firstChild}
                    {secondChild}
                </Row>
            )
        }

        return rows
    }, [children])

    return (
        <div>
            {outputChildren}
        </div>
    )
}

export default DoubleColumn